export const apiConfig = {
    url: 'https://mcfood.kz/',
    firebaseId: "ewj6k-OO_8w:APA91bHTa1dTzrM2lIkyd0M2uPXu__3aopMo0QQV8Ae6EmLtgwD_lK8pkcGOG72hXo4Q3fUfBXTl37YoRJ5KkbTGLaVC8ELGfwLiAe9vvO9GSI3AViUONHrIRSqBbXrn9ML1a_KXfNlF"
}